import React, { useState, useEffect } from 'react';
import { Menu, X, ChevronRight, Shield, Code, Globe, Server,Cpu, Network, FileCode, Sun, Moon, ChevronLeft, Mail, Phone, MapPin, Facebook, Instagram, Linkedin, Twitter } from 'lucide-react';
import Header from "../Header";
import Footer from "../Footer";
import { useNavigate } from "react-router-dom";
import api from '../api/Api';
import QuoteModal from '../ModalOrcamento';

export default function AngoNetWebsite({ isDarkMode, setIsDarkMode }) {
  //const URL_BASE = 'http://127.0.0.1:8000/storage/img/servicos/';
  //const URL_PARTNER = 'http://127.0.0.1:8000/storage/img/parceiros/';

const URL_BASE ='https://api.angonet.ao/public/img/servicos/';

const URL_PARTNER = 'https://api.angonet.ao/public/img/parceiros/';

  const [isScrolled, setIsScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [activeService, setActiveService] = useState(0);
  const navigate = useNavigate();
  const [currentSlide, setCurrentSlide] = useState(0);
  const [currentPartner, setCurrentPartner] = useState(0);
  const [bannerSlides, setBannerSlides] = useState([]);
  const [loading, setLoading] = useState(true);
  const [partners, setpartners] = useState([]);
    const [isQuoteModalOpen, setIsQuoteModalOpen] = useState(false);
const [preSelectedService, setPreSelectedService] = useState(null);

  const [services, setservices] = useState([]);
    const iconMap = {
  'Shield': Shield,
  'Network': Network,
  'Globe': Globe,
  'Code': Code,
  'FileCode': FileCode,
  'Server': Server,
  'Cpu': Cpu
};
const getIconComponent = (iconName) => {
  return iconMap[iconName] || Shield; // Shield como fallback
};

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // Auto-rotate banner carousel
  useEffect(() => {
    if (bannerSlides.length > 0) {
      const interval = setInterval(() => {
        setCurrentSlide((prev) => (prev + 1) % bannerSlides.length);
      }, 5000);
      return () => clearInterval(interval);
    }
  }, [bannerSlides.length]);

  // Auto-rotate partners carousel
useEffect(() => {
  if (partners.length > 0) {
    const interval = setInterval(() => {
      setCurrentPartner((prev) => (prev + 1) % partners.length);
    }, 3000);

    return () => clearInterval(interval);
  }
}, [partners.length]);


  useEffect(() => {
    document.title = "Início";
    fetchBanner();
    fetchServico();
    fetchParceiro();
  }, []);


  const fetchParceiro = async () => {
    setLoading(true);
    try {
      const response = await api.ListParceiro();

      

      const dados = Array.isArray(response) ? response : [];

      const formatado = dados.map(item => ({
        logo: `${URL_PARTNER}${item.logo}`,
        name:item.nome || '',
         
      }));

      setpartners(formatado);
    } catch (error) {
       
    } finally {
      setLoading(false);
    }
  };









const fetchServico = async () => {
  setLoading(true);
  try {
    const response = await api.ListServico();

    const dados = Array.isArray(response) ? response : [];

    const formatado = dados.map(item => ({
      icon: item.icon || '',
      title: item.titulo || '',
      description: item.subtitulo || '',
      color: item.cor || 'from-violet-600 to-blue-500',
      code: item.code // 👈 IMPORTANTE
    }));

    setservices(formatado);
  } catch (error) {
    
  } finally {
    setLoading(false);
  }
};





const fetchBanner = async () => {
  setLoading(true);
  try {
    const response = await api.ListBanner();

    const dados = Array.isArray(response) ? response : [];

    const formatado = dados.map(item => ({
      title: item.titulo || '',
      subtitle: item.subtitulo || '',
      image: `${URL_BASE}${item.img}`,
      cta: "Saber Mais",
      code: item.code // 👈 IMPORTANTE
    }));

    setBannerSlides(formatado);
  } catch (error) {
    setBannerSlides([
      {
        title: "Transforme o seu Negócio com Tecnologia",
        subtitle: "Soluções inovadoras para empresas modernas",
        image: "https://images.unsplash.com/photo-1451187580459-43490279c0fa?w=1200&h=600&fit=crop",
        cta: "Saber Mais",
        code: null
      }
    ]);
  } finally {
    setLoading(false);
  }
};



 

  return (
    <div className={`min-h-screen overflow-x-hidden transition-colors duration-300 ${
      isDarkMode ? 'bg-gray-900 text-white' : 'bg-white text-gray-900'
    }`}>
      {/* Animated Background */}
      <div className="fixed inset-0 overflow-hidden pointer-events-none">
        <div className={`absolute top-0 right-0 w-[800px] h-[800px] rounded-full blur-[120px] animate-pulse ${
          isDarkMode ? 'bg-blue-500/10' : 'bg-blue-400/20'
        }`}></div>
        <div className={`absolute bottom-0 left-0 w-[600px] h-[600px] rounded-full blur-[120px] animate-pulse ${
          isDarkMode ? 'bg-purple-500/10' : 'bg-purple-500/20'
        }`} style={{animationDelay: '1s'}}></div>
        <div className={`absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-[400px] h-[400px] rounded-full blur-[100px] animate-pulse ${
          isDarkMode ? 'bg-cyan-500/5' : 'bg-cyan-400/15'
        }`} style={{animationDelay: '2s'}}></div>
        
        {/* Floating particles */}
        <div className="absolute top-[20%] left-[15%] w-1 h-1 bg-blue-500 rounded-full animate-float"></div>
        <div className="absolute top-[40%] right-[20%] w-1.5 h-1.5 bg-cyan-500 rounded-full animate-float" style={{animationDelay: '1s'}}></div>
        <div className="absolute top-[60%] left-[30%] w-1 h-1 bg-purple-500 rounded-full animate-float" style={{animationDelay: '2s'}}></div>
        <div className="absolute top-[80%] right-[40%] w-2 h-2 bg-blue-400 rounded-full animate-float" style={{animationDelay: '0.5s'}}></div>
        <div className="absolute top-[30%] right-[10%] w-1 h-1 bg-cyan-400 rounded-full animate-float" style={{animationDelay: '1.5s'}}></div>
        <div className="absolute top-[70%] left-[50%] w-1.5 h-1.5 bg-purple-400 rounded-full animate-float" style={{animationDelay: '2.5s'}}></div>
      </div>

      {/* Navigation */}
      <Header 
        isDarkMode={isDarkMode} 
        setIsDarkMode={setIsDarkMode} 
      />

      {/* Banner Carousel */}
      <section className="relative pt-20 overflow-hidden">
        <div className="relative h-[500px] md:h-[600px]">
          {loading ? (
            // Loading skeleton
            <div className={`absolute inset-0 flex items-center justify-center ${
              isDarkMode ? 'bg-gray-800' : 'bg-gray-200'
            }`}>
              <div className="text-center">
                <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto mb-4"></div>
                <p className={isDarkMode ? 'text-gray-400' : 'text-gray-600'}>
                  Carregando banners...
                </p>
              </div>
            </div>
          ) : bannerSlides.length > 0 ? (
            <>
              {bannerSlides.map((slide, index) => (
                <div
                  key={index}
                  className={`absolute inset-0 transition-all duration-1000 ${
                    index === currentSlide ? 'opacity-100 scale-100' : 'opacity-0 scale-105'
                  }`}
                >
                  <div className="absolute inset-0 bg-gradient-to-r from-black/70 to-black/30 z-10"></div>
                  <img
                    src={slide.image}
                    alt={slide.title}
                    className="w-full h-full object-cover"
                    onError={(e) => {
                      // Fallback se a imagem falhar ao carregar
                      e.target.src = 'https://images.unsplash.com/photo-1451187580459-43490279c0fa?w=1200&h=600&fit=crop';
                    }}
                  />
                  <div className="absolute inset-0 z-20 flex items-center justify-center">
                    <div className="max-w-4xl mx-auto text-center px-6">
                      <h2 className="text-4xl md:text-6xl font-bold text-white mb-4 animate-fade-in-up">
                        {slide.title}
                      </h2>
                      <p className="text-xl md:text-2xl text-gray-200 mb-8 animate-fade-in-up" style={{animationDelay: '0.2s'}}>
                        {slide.subtitle}
                      </p>
<button
  onClick={() => {
    const activeSlide = bannerSlides[currentSlide];
    if (activeSlide?.code) {
      navigate(`/servicos/${activeSlide.code}`);
    }
  }}
  className="px-8 py-4 bg-gradient-to-r from-blue-600 to-purple-600 text-white rounded-full font-semibold hover:shadow-2xl hover:shadow-blue-500/50 transition-all animate-fade-in-up"
  style={{ animationDelay: '0.4s' }}
>
  {slide.cta}
</button>


                    </div>
                  </div>
                </div>
              ))}

              {/* Navigation Arrows */}
              <button
                onClick={() => setCurrentSlide((prev) => (prev - 1 + bannerSlides.length) % bannerSlides.length)}
                className="absolute left-4 top-1/2 -translate-y-1/2 z-30 p-3 bg-white/10 backdrop-blur-sm rounded-full hover:bg-white/20 transition-all"
              >
                <ChevronLeft className="text-white" size={24} />
              </button>
              <button
                onClick={() => setCurrentSlide((prev) => (prev + 1) % bannerSlides.length)}
                className="absolute right-4 top-1/2 -translate-y-1/2 z-30 p-3 bg-white/10 backdrop-blur-sm rounded-full hover:bg-white/20 transition-all"
              >
                <ChevronRight className="text-white" size={24} />
              </button>

              {/* Dots Indicator */}
              <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-30 flex space-x-2">
                {bannerSlides.map((_, index) => (
                  <button
                    key={index}
                    onClick={() => setCurrentSlide(index)}
                    className={`w-3 h-3 rounded-full transition-all ${
                      index === currentSlide ? 'bg-white w-8' : 'bg-white/50'
                    }`}
                  />
                ))}
              </div>
            </>
          ) : (
            // Fallback quando não há banners
            <div className={`absolute inset-0 flex items-center justify-center ${
              isDarkMode ? 'bg-gray-800' : 'bg-gray-200'
            }`}>
              <p className={isDarkMode ? 'text-gray-400' : 'text-gray-600'}>
                Nenhum banner disponível no momento
              </p>
            </div>
          )}
        </div>
      </section>

      {/* Hero Section */}
      <section id="home" className="relative py-24 flex items-center justify-center px-6">

        <div className="max-w-7xl mx-auto text-center relative z-10">
          <div className={`inline-block mb-6 px-4 py-2 border rounded-full backdrop-blur-sm animate-fade-in ${
            isDarkMode 
              ? 'bg-blue-500/10 border-blue-500/30 text-cyan-400' 
              : 'bg-blue-500/10 border-blue-500/30 text-blue-600'
          }`}>
            <span className="text-sm font-semibold">Tecnologia que Transforma</span>
          </div>
          
          <h1 className={`text-5xl md:text-7xl font-bold mb-6 leading-tight animate-fade-in-up ${
            isDarkMode ? 'text-white' : 'text-gray-900'
          }`} style={{animationDelay: '0.2s'}}>
            Soluções Tecnológicas
            <br />
            <span className="bg-gradient-to-r from-blue-600 via-cyan-500 to-purple-600 bg-clip-text text-transparent">
              Inovadoras
            </span>
            {' '}para Angola
          </h1>
          
          <p className={`text-xl mb-12 max-w-3xl mx-auto animate-fade-in-up ${
            isDarkMode ? 'text-gray-400' : 'text-gray-600'
          }`} style={{animationDelay: '0.4s'}}>
            Da segurança digital ao desenvolvimento de software, oferecemos serviços completos 
            de tecnologia para impulsionar o seu negócio.
          </p>
          
          <div className="flex flex-col sm:flex-row gap-4 justify-center animate-fade-in-up" style={{animationDelay: '0.6s'}}>
            <button 
              onClick={() => navigate('/servicos')}
              className="px-8 py-4 bg-gradient-to-r from-blue-600 to-purple-600 text-white rounded-full font-semibold hover:shadow-2xl hover:shadow-blue-500/50 transition-all transform hover:scale-105"
            >
              Explorar Serviços
            </button>
          </div>

          {/* Neon glowing particles */}
          <div className="absolute top-1/4 left-1/4 w-3 h-3 bg-blue-500 rounded-full blur-sm shadow-[0_0_20px_rgba(59,130,246,0.8)] animate-float"></div>
          <div className="absolute top-1/3 right-1/4 w-4 h-4 bg-cyan-400 rounded-full blur-sm shadow-[0_0_25px_rgba(34,211,238,0.8)] animate-float" style={{animationDelay: '1s'}}></div>
          <div className="absolute bottom-1/4 left-1/3 w-3 h-3 bg-purple-500 rounded-full blur-sm shadow-[0_0_20px_rgba(168,85,247,0.8)] animate-float" style={{animationDelay: '2s'}}></div>
        </div>

        {/* Scroll Indicator */}
        <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
          <ChevronRight className={isDarkMode ? 'rotate-90 text-cyan-400' : 'rotate-90 text-blue-600'} size={32} />
        </div>
      </section>

      {/* Services Section */}
      <section id="services" className={`relative py-24 px-6 ${isDarkMode ? 'bg-gray-800/30' : 'bg-gray-50/50'}`}>
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-16">
            <h2 className={`text-4xl md:text-6xl font-bold mb-4 ${isDarkMode ? 'text-white' : 'text-gray-900'}`}>
              Nossos <span className="bg-gradient-to-r from-blue-600 to-purple-600 bg-clip-text text-transparent">Serviços</span>
            </h2>
            <p className={`text-lg max-w-2xl mx-auto ${isDarkMode ? 'text-gray-400' : 'text-gray-600'}`}>
              Oferecemos soluções completas em tecnologia, desde infraestrutura até desenvolvimento de software
            </p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
            {services.map((service, index) => {
                const IconComponent = getIconComponent(service.icon);

              return (
                <div
                  key={index}
                    onClick={() => service.code && navigate(`/servicos/${service.code}`)}

                  className={`group relative rounded-2xl p-8 transition-all duration-300 cursor-pointer ${
                    isDarkMode
                      ? 'bg-white/5 border border-white/10 hover:border-cyan-500/50 hover:shadow-2xl hover:shadow-cyan-500/20'
                      : 'bg-white border border-gray-200 hover:border-blue-500/50 hover:shadow-2xl hover:shadow-blue-500/20'
                  }`}
                  onMouseEnter={() => setActiveService(index)}
                  style={{
                    animationDelay: `${index * 0.1}s`
                  }}
                >
                  <div className={`inline-flex p-4 bg-gradient-to-r ${service.color} rounded-xl mb-6 group-hover:scale-110 transition-transform shadow-lg`}>
                          <IconComponent size={32} className="text-white" />

                  </div>
                  
                  <h3 className={`text-2xl font-bold mb-4 transition-colors ${
                    isDarkMode
                      ? 'text-white group-hover:text-cyan-400'
                      : 'text-gray-900 group-hover:text-blue-600'
                  }`}>
                    {service.title}
                  </h3>
                  
                  <p className={`leading-relaxed ${isDarkMode ? 'text-gray-400' : 'text-gray-600'}`}>
                    {service.description}
                  </p>

                  <div className={`mt-6 flex items-center font-semibold opacity-0 group-hover:opacity-100 transition-opacity ${
                    isDarkMode ? 'text-cyan-400' : 'text-blue-600'
                  }`}>
                    Saber mais
                    <ChevronRight size={20} className="ml-2 group-hover:translate-x-1 transition-transform" />
                  </div>

                  {/* Hover glow effect */}
                  <div className={`absolute inset-0 bg-gradient-to-r ${service.color} opacity-0 group-hover:opacity-5 rounded-2xl transition-opacity blur-xl pointer-events-none`}></div>
                </div>
              );
            })}
          </div>
        </div>
      </section>

      {/* Stats Section */}
      <section className={`relative py-16 px-6 border-y ${
        isDarkMode 
          ? 'bg-gradient-to-br from-blue-950/30 to-purple-950/30 border-white/10'
          : 'bg-gradient-to-br from-blue-50 to-purple-50 border-gray-200'
      }`}>
        <div className="max-w-7xl mx-auto">
          <div className="flex flex-wrap items-center justify-center gap-8 md:gap-16">
            <div className="text-center animate-fade-in-up">
              <div className="text-4xl md:text-5xl font-bold bg-gradient-to-r from-blue-600 to-cyan-500 bg-clip-text text-transparent mb-2">
                20+
              </div>
              <div className={`text-sm md:text-base font-medium ${isDarkMode ? 'text-gray-400' : 'text-gray-700'}`}>
                Projectos Concluídos
              </div>
            </div>
            
            <div className={`hidden md:block w-px h-16 ${isDarkMode ? 'bg-white/10' : 'bg-gray-300'}`}></div>
            
            <div className="text-center animate-fade-in-up" style={{animationDelay: '0.1s'}}>
              <div className="text-4xl md:text-5xl font-bold bg-gradient-to-r from-cyan-500 to-purple-600 bg-clip-text text-transparent mb-2">
                200+
              </div>
              <div className={`text-sm md:text-base font-medium ${isDarkMode ? 'text-gray-400' : 'text-gray-700'}`}>
                Clientes Satisfeitos
              </div>
            </div>
            
            <div className={`hidden md:block w-px h-16 ${isDarkMode ? 'bg-white/10' : 'bg-gray-300'}`}></div>
            
        
            
            
            
            <div className="text-center animate-fade-in-up" style={{animationDelay: '0.3s'}}>
              <div className="text-4xl md:text-5xl font-bold bg-gradient-to-r from-violet-600 to-blue-600 bg-clip-text text-transparent mb-2">
                24/7
              </div>
              <div className={`text-sm md:text-base font-medium ${isDarkMode ? 'text-gray-400' : 'text-gray-700'}`}>
                Suporte Técnico
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* About Section */}
      <section id="about" className="relative py-24 px-6">
        <div className="max-w-7xl mx-auto">
          <div className="grid md:grid-cols-2 gap-12 items-center">
            <div>
              <h2 className={`text-4xl md:text-5xl font-bold mb-6 ${isDarkMode ? 'text-white' : 'text-gray-900'}`}>
                Tecnologia e <span className="bg-gradient-to-r from-blue-600 to-purple-600 bg-clip-text text-transparent">Inovação</span> em Angola
              </h2>
              <p className={`text-lg mb-6 leading-relaxed ${isDarkMode ? 'text-gray-400' : 'text-gray-600'}`}>
                A AngoNet é uma empresa angolana dedicada a fornecer soluções tecnológicas de excelência. 
                Combinamos expertise técnica com inovação para transformar a forma como as empresas operam.
              </p>
              <p className={`text-lg mb-8 leading-relaxed ${isDarkMode ? 'text-gray-400' : 'text-gray-600'}`}>
                Com uma equipa altamente qualificada, oferecemos desde sistemas de segurança 
                avançados até desenvolvimento de software personalizado, sempre focados na qualidade e 
                satisfação dos nossos clientes.
              </p>
              <button 
                onClick={() => navigate('/contacto')}
                className="px-8 py-4 bg-gradient-to-r from-blue-600 to-purple-600 text-white rounded-full font-semibold hover:shadow-2xl hover:shadow-blue-500/50 transition-all"
              >
                Contactar-nos
              </button>
            </div>

            <div className="relative">
              <div className={`aspect-square rounded-2xl border backdrop-blur-sm flex items-center justify-center shadow-xl ${
                isDarkMode
                  ? 'bg-gradient-to-br from-blue-500/20 to-purple-500/20 border-white/10'
                  : 'bg-gradient-to-br from-blue-100 to-purple-100 border-gray-200'
              }`}>
                <div className="text-center p-8">
                  <Cpu size={120} className={`mx-auto mb-6 ${isDarkMode ? 'text-cyan-400' : 'text-blue-600'}`} />
                  <h3 className={`text-2xl font-bold mb-4 ${isDarkMode ? 'text-white' : 'text-gray-900'}`}>Parceiro em Tecnologia</h3>
                  <p className={isDarkMode ? 'text-gray-400' : 'text-gray-600'}>
                    Impulsionando a transformação digital em Angola
                  </p>
                </div>
              </div>
              {/* Decorative neon glows */}
              <div className="absolute -top-4 -left-4 w-24 h-24 bg-blue-400/30 rounded-full blur-2xl"></div>
              <div className="absolute -bottom-4 -right-4 w-32 h-32 bg-purple-400/30 rounded-full blur-2xl"></div>
            </div>
          </div>
        </div>
      </section>

      {/* Partners Section */}
      <section className={`relative py-16 px-6 border-y ${
        isDarkMode ? 'bg-gray-800/20 border-white/10' : 'bg-gray-100 border-gray-200'
      }`}>
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-12">
            <h2 className={`text-3xl md:text-4xl font-bold mb-2 ${isDarkMode ? 'text-white' : 'text-gray-900'}`}>
              Nossos <span className="bg-gradient-to-r from-blue-600 to-purple-600 bg-clip-text text-transparent">Parceiros</span>
            </h2>
            <p className={`${isDarkMode ? 'text-gray-400' : 'text-gray-600'}`}>
              Empresas que confiam na AngoNet
            </p>
          </div>

          <div className="relative overflow-hidden">
            {/* Main Partner Display */}
 <div className="flex items-center justify-center min-h-[250px]">
  <div className="relative w-full max-w-md">
    {partners.map((partner, index) => (
      <div
        key={index}
        className={`absolute inset-0 flex items-center justify-center transition-all duration-700 ${
          index === currentPartner 
            ? 'opacity-100 scale-100 translate-x-0' 
            : index < currentPartner
            ? 'opacity-0 scale-95 -translate-x-full'
            : 'opacity-0 scale-95 translate-x-full'
        }`}
      >
        <div
          className={`
            w-full aspect-video 
            p-10 
            rounded-3xl 
            transition-all duration-500 
            flex items-center justify-center
            backdrop-blur-xl
            ${
              isDarkMode
                ? 'bg-white/5 border border-white/10 shadow-[0_0_40px_rgba(59,130,246,0.1)] hover:shadow-[0_0_60px_rgba(59,130,246,0.2)]'
                : 'bg-white border border-gray-200 shadow-xl hover:shadow-2xl'
            }
          `}
        >
          <img
            src={partner.logo}
            alt={partner.name}
            className="max-h-32 w-auto object-contain transition-all duration-500 opacity-80 hover:opacity-100 hover:scale-105"
          />
        </div>
      </div>
    ))}
  </div>
</div>


            {/* Navigation Arrows */}
            <button
              onClick={() => setCurrentPartner((prev) => (prev - 1 + partners.length) % partners.length)}
              className={`absolute left-4 md:left-1/4 top-1/2 -translate-y-1/2 p-3 rounded-full transition-all ${
                isDarkMode
                  ? 'bg-white/10 hover:bg-white/20 text-white'
                  : 'bg-white hover:bg-gray-100 text-gray-700 shadow-lg'
              }`}
            >
              <ChevronLeft size={24} />
            </button>
            <button
              onClick={() => setCurrentPartner((prev) => (prev + 1) % partners.length)}
              className={`absolute right-4 md:right-1/4 top-1/2 -translate-y-1/2 p-3 rounded-full transition-all ${
                isDarkMode
                  ? 'bg-white/10 hover:bg-white/20 text-white'
                  : 'bg-white hover:bg-gray-100 text-gray-700 shadow-lg'
              }`}
            >
              <ChevronRight size={24} />
            </button>

            {/* Navigation Dots */}
            <div className="flex justify-center mt-8 space-x-2">
              {partners.map((_, index) => (
                <button
                  key={index}
                  onClick={() => setCurrentPartner(index)}
                  className={`h-2 rounded-full transition-all ${
                    index === currentPartner
                      ? isDarkMode 
                        ? 'bg-cyan-400 w-8' 
                        : 'bg-blue-600 w-8'
                      : isDarkMode 
                        ? 'bg-gray-600 w-2' 
                        : 'bg-gray-300 w-2'
                  }`}
                />
              ))}
            </div>

            {/* Partner Counter */}
            <div className={`text-center mt-4 text-sm ${isDarkMode ? 'text-gray-500' : 'text-gray-400'}`}>
              {currentPartner + 1} / {partners.length}
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className={`relative py-24 px-6 ${isDarkMode ? 'bg-gray-900' : 'bg-gray-50'}`}>
        <div className="max-w-5xl mx-auto text-center">
          <div className={`rounded-3xl p-12 backdrop-blur-sm ${
            isDarkMode
              ? 'bg-gradient-to-br from-blue-500/10 to-purple-500/10 border border-white/10'
              : 'bg-gradient-to-br from-blue-100 to-purple-100 border border-gray-200 shadow-xl'
          }`}>
            <h2 className={`text-4xl md:text-5xl font-bold mb-6 ${isDarkMode ? 'text-white' : 'text-gray-900'}`}>
              Pronto para Inovar?
            </h2>
            <p className={`text-lg mb-8 max-w-2xl mx-auto ${isDarkMode ? 'text-gray-400' : 'text-gray-700'}`}>
              Entre em contacto connosco e descubra como as nossas soluções tecnológicas 
              podem transformar o seu negócio.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <button 
               onClick={() => setIsQuoteModalOpen(true)}
              className="px-8 py-4 bg-gradient-to-r from-blue-600 to-purple-600 text-white rounded-full font-semibold hover:shadow-2xl hover:shadow-blue-500/50 transition-all">
                Solicitar Orçamento
              </button>
   
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <Footer isDarkMode={isDarkMode} />

      <style jsx>{`
        @keyframes fade-in {
          from {
            opacity: 0;
          }
          to {
            opacity: 1;
          }
        }

        @keyframes fade-in-up {
          from {
            opacity: 0;
            transform: translateY(30px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        @keyframes float {
          0%, 100% {
            transform: translateY(0px);
          }
          50% {
            transform: translateY(-20px);
          }
        }

        .animate-fade-in {
          animation: fade-in 0.8s ease-out forwards;
        }

        .animate-fade-in-up {
          animation: fade-in-up 0.8s ease-out forwards;
        }

        .animate-float {
          animation: float 3s ease-in-out infinite;
        }
      `}</style>

              <QuoteModal
        isOpen={isQuoteModalOpen}
        onClose={() => setIsQuoteModalOpen(false)}
        isDarkMode={isDarkMode}
        preSelectedService={preSelectedService}  
      />
    </div>
  );
}